export enum AssignmentCDCUpToDateStatusEnum {
  GREEN = 'Green',
  AMBER = 'Amber',
  RED = 'Red',
}
